import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { patchRequest } from "services/api";
import Swal from "sweetalert2";

const ManualStockUpdateModal = ({ show, onHide, item, warehouses, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    warehouse_id: "",
    quantity: 1,
    type: "in",
    reason: "",
  });

  useEffect(() => {
    if (show && warehouses && warehouses.length > 0) {
      setFormData({
        warehouse_id: warehouses[0].id,
        quantity: 1,
        type: "in",
        reason: "",
      });
    }
  }, [show, warehouses]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "quantity" ? parseInt(value) || 0 : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.warehouse_id || !formData.reason.trim()) {
      Swal.fire("Warning", "Please fill in all required fields", "warning");
      return;
    }

    setLoading(true);
    try {
      const response = await patchRequest(`/inventory/${item.id}/stock`, formData);
      if (response && response.success) {
        Swal.fire("Success", "Stock updated successfully", "success");
        onSuccess && onSuccess();
        onHide();
      } else {
        throw new Error(response?.message || "Failed to update stock");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Failed to update stock", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="workshop-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title>Update Stock Manually</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Item Name</Form.Label>
            <Form.Control type="text" value={item?.name || ""} disabled />
          </Form.Group>

          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Warehouse *</Form.Label>
                <Form.Select
                  name="warehouse_id"
                  value={formData.warehouse_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Warehouse</option>
                  {warehouses.map((w) => (
                    <option key={w.id} value={w.id}>
                      {w.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Transaction Type *</Form.Label>
                <Form.Select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  required
                >
                  <option value="in">Stock In (+)</option>
                  <option value="out">Stock Out (-)</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Quantity *</Form.Label>
                <Form.Control
                  type="number"
                  name="quantity"
                  min="1"
                  value={formData.quantity}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Reason *</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              placeholder="e.g. Restock from supplier, used for service, etc."
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? <Spinner size="sm" className="me-2" /> : null}
            Update Stock
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ManualStockUpdateModal;
